import styled from "styled-components";
import { buttonBaseStyles, onClickWithAnalytics } from "./common";
import { ButtonCommonProps } from "./types";
import { KeyColors } from "@/theme/colors";

/**
 * Styled Components
 */

interface StyledButtonProps extends Omit<ButtonCommonProps, "text"> {
  $borderColor?: KeyColors;
  $textColor?: KeyColors;
}

export const StyledButtonRegular = styled.button<StyledButtonProps>`
  ${
    // @ts-expect-error check this error with styled-components
    buttonBaseStyles
  };
  ${({ theme, color, $borderColor, $textColor, type }) => `
    display: flex;
    justify-content: ${type === "restart" ? "space-between" : "center"};
    gap: 8px;
    background-color: ${
      color ? theme.Colors[color as KeyColors] : theme.Colors.black
    };
    border-bottom: 5px solid ${
      $borderColor
        ? theme.Colors[$borderColor as KeyColors]
        : theme.Colors.white
    };

    color: ${$textColor ? theme.Colors[$textColor] : theme.Colors.white};
    border-radius: 12px;
    padding: 12px;

    &:hover {
      opacity: 0.9;
    }

    &:disabled {
      background-color: ${theme.Colors.gray200};
      color: ${theme.Colors.gray300};
      border-color: ${theme.Colors.gray200};
      cursor: not-allowed;
      opacity: 0.7;
    }
  `}
`;

/**
 * ButtonGameRegular Component
 */

interface ButtonGameRegularProps extends ButtonCommonProps {
  borderColor?: KeyColors;
  textColor?: KeyColors;
}

export const ButtonGameRegular = ({
  disabled = false,
  onClick,
  testId,
  text,
  color = "black",
  type = "button",
  borderColor = "white",
  textColor,
  icon,
  analyticsContext,
  ...rest
}: ButtonGameRegularProps) => (
  <StyledButtonRegular
    disabled={disabled}
    data-testid={testId}
    onClick={() =>
      onClickWithAnalytics(onClick, {
        button_text: text,
        button_type: type,
        ...analyticsContext ?? {},
      })
    }
    type={type}
    color={color}
    $borderColor={borderColor}
    $textColor={textColor}
    {...rest}
  >
    {text}
    {icon}
  </StyledButtonRegular>
);
